import React from 'react'

// Leilão beneficente: a comissão zerada do leilão vale por padrão; opcionalmente respeita
// as comissões individuais cadastradas nos clientes.
const ComissaoBeneficenteOpcao = ({ respeitarIndividual, onChange, disabled = false }) => (
  <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
    <p className="text-sm font-medium text-green-800 mb-3">Comissão no faturamento do leilão beneficente</p>
    <label className="flex items-start gap-2 mb-2 cursor-pointer">
      <input
        type="radio"
        name="comissao_beneficente_modo"
        className="mt-1"
        checked={!respeitarIndividual}
        disabled={disabled}
        onChange={() => onChange(false)}
      />
      <span className="text-sm text-gray-700">
        Usar a comissão do leilão (Beneficente 0%) — ignora a comissão individual dos clientes <em>(padrão)</em>
      </span>
    </label>
    <label className="flex items-start gap-2 cursor-pointer">
      <input
        type="radio"
        name="comissao_beneficente_modo"
        className="mt-1"
        checked={!!respeitarIndividual}
        disabled={disabled}
        onChange={() => onChange(true)}
      />
      <span className="text-sm text-gray-700">Respeitar as comissões individuais do cadastro do cliente</span>
    </label>
  </div>
)

export default ComissaoBeneficenteOpcao
